import { ReceiptDetailDto } from "../../store/models/CustomerInteractionDto";

export const receiptDetailExamplesToom: ReceiptDetailDto[] = [
  {
    "amount": "1.000",
    "salesPrice": "119.99",
    "originalPrice": "119.99",
    "itemInfo": {
      "productGroupNumber": 5000,
      "productGroupDesc": "Werkstatt & Maschinen",
      "subGroupNumber": 500010,
      "subGroupDesc": "Akkuschrauber & Bohrschrauber",
      "supplierNumber": 4021,
      "supplierDesc": "Bosch Professional",
      "supplierItemText": "Akku-Bohrschrauber GSR 12V-15 Professional",
      "refNumber": "1490300",
      "rating": 4.8,
      "votings": 1287,
      "organic": false,
      "salesAreaNumber": 210,
      "salesAreaDesc": "Elektrowerkzeuge",
      "ean": "3165140843710"
    }
  },
  {
    "amount": "1.000",
    "salesPrice": "359.99",
    "originalPrice": "359.99",
    "itemInfo": {
      "productGroupNumber": 5000,
      "productGroupDesc": "Werkstatt & Maschinen",
      "subGroupNumber": 500120,
      "subGroupDesc": "Kreuzlinienlaser & Linienlaser",
      "supplierNumber": 4021,
      "supplierDesc": "Bosch Professional",
      "supplierItemText": "Linienlaser Professional GLL 3-50 mit Laserzieltatel",
      "refNumber": "1490396",
      "rating": 4.7,
      "votings": 842,
      "organic": false,
      "salesAreaNumber": 215,
      "salesAreaDesc": "Messwerkzeuge",
      "ean": "7395820017463"
    }
  },
  {
    "amount": "1.000",
    "salesPrice": "21.99",
    "originalPrice": "21.99",
    "itemInfo": {
      "productGroupNumber": 5000,
      "productGroupDesc": "Werkstatt & Maschinen",
      "subGroupNumber": 500220,
      "subGroupDesc": "Dübel & Befestigungstechnik",
      "supplierNumber": 4075,
      "supplierDesc": "Fischer",
      "supplierItemText": "Nylon-Kippdübel 'Duotec' Ø 10 x 50 mm, 20 Stück",
      "refNumber": "1550278",
      "rating": 4.6,
      "votings": 312,
      "organic": false,
      "salesAreaNumber": 240,
      "salesAreaDesc": "Eisenwaren & Beschläge",
      "ean": "8945217763048"
    }
  },

  {
    "amount": "1.000",
    "salesPrice": "129.99",
    "originalPrice": "129.99",
    "itemInfo": {
      "productGroupNumber": 6000,
      "productGroupDesc": "Bad & Sanitär",
      "subGroupNumber": 600110,
      "subGroupDesc": "Waschbecken",
      "supplierNumber": 5310,
      "supplierDesc": "Villeroy & Boch",
      "supplierItemText": "Waschbecken eckig 'Architectura' weiß 60 x 62,2 x 48,8 cm",
      "refNumber": "5100804",
      "rating": 4.9,
      "votings": 154,
      "organic": false,
      "salesAreaNumber": 310,
      "salesAreaDesc": "Sanitärausstattung",
      "ean": "7429810064128"
    }
  },
  {
    "amount": "1.000",
    "salesPrice": "79.99",
    "originalPrice": "79.99",
    "itemInfo": {
      "productGroupNumber": 6000,
      "productGroupDesc": "Bad & Sanitär",
      "subGroupNumber": 600210,
      "subGroupDesc": "Waschtischarmaturen",
      "supplierNumber": 5215,
      "supplierDesc": "Hansgrohe",
      "supplierItemText": "Waschtischarmatur 'Logis E' chrom",
      "refNumber": "5400507",
      "rating": 4.8,
      "votings": 417,
      "organic": false,
      "salesAreaNumber": 315,
      "salesAreaDesc": "Badarmaturen",
      "ean": "7851023498816"
    }
  },
  {
    "amount": "1.000",
    "salesPrice": "69.99",
    "originalPrice": "69.99",
    "itemInfo": {
      "productGroupNumber": 7000,
      "productGroupDesc": "Wohnen & Haushalt",
      "subGroupNumber": 700140,
      "subGroupDesc": "Deckenleuchten",
      "supplierNumber": 4610,
      "supplierDesc": "Eglo",
      "supplierItemText": "Deckenleuchte 'Townshend' schwarz/braun 10,5 x 26,5 cm",
      "refNumber": "9242070",
      "rating": 4.7,
      "votings": 529,
      "organic": false,
      "salesAreaNumber": 410,
      "salesAreaDesc": "Lampen & Leuchten",
      "ean": "9834710028561"
    }
  },
  {
    "amount": "1.000",
    "salesPrice": "32.99",
    "originalPrice": "32.99",
    "itemInfo": {
      "productGroupNumber": 3000,
      "productGroupDesc": "Bauen & Renovieren",
      "subGroupNumber": 300410,
      "subGroupDesc": "Wandfarben",
      "supplierNumber": 6205,
      "supplierDesc": "StilTalent (toom Eigenmarke)",
      "supplierItemText": "Wandfarbe 'herbal love' matt 2,5 l",
      "refNumber": "8111552",
      "rating": 4.7,
      "votings": 263,
      "organic": false,
      "salesAreaNumber": 510,
      "salesAreaDesc": "Farben, Lacke & Holzschutz",
      "ean": "8752103499126"
    }
  },
  {
    "amount": "1.000",
    "salesPrice": "17.49",
    "originalPrice": "17.49",
    "itemInfo": {
      "productGroupNumber": 3000,
      "productGroupDesc": "Bauen & Renovieren",
      "subGroupNumber": 300420,
      "subGroupDesc": "Malerbedarf",
      "supplierNumber": 6710,
      "supplierDesc": "contractor",
      "supplierItemText": "Farbwalze 'LoTex' rau 25 cm",
      "refNumber": "8301755",
      "rating": 4.6,
      "votings": 189,
      "organic": false,
      "salesAreaNumber": 520,
      "salesAreaDesc": "Farbenzubehör",
      "ean": "9128473001568"
    }
  },
  {
    "amount": "1.000",
    "salesPrice": "5.99",
    "originalPrice": "5.99",
    "itemInfo": {
      "productGroupNumber": 3000,
      "productGroupDesc": "Bauen & Renovieren",
      "subGroupNumber": 300420,
      "subGroupDesc": "Malerbedarf",
      "supplierNumber": 6700,
      "supplierDesc": "toom",
      "supplierItemText": "Steckbügel 'Premium' Stahl 25 cm",
      "refNumber": "8301074",
      "rating": 4.5,
      "votings": 87,
      "organic": false,
      "salesAreaNumber": 520,
      "salesAreaDesc": "Farbenzubehör",
      "ean": "9037215009824"
    }
  },
  {
    "amount": "1.000",
    "salesPrice": "49.99",
    "originalPrice": "49.99",
    "itemInfo": {
      "productGroupNumber": 3000,
      "productGroupDesc": "Bauen & Renovieren",
      "subGroupNumber": 300410,
      "subGroupDesc": "Wandfarben",
      "supplierNumber": 6700,
      "supplierDesc": "toom",
      "supplierItemText": "Premiumweiß matt 10 l",
      "refNumber": "8101406",
      "rating": 4.8,
      "votings": 982,
      "organic": false,
      "salesAreaNumber": 510,
      "salesAreaDesc": "Farben, Lacke & Holzschutz",
      "ean": "9027815409326"
    }
  },
  {
    "amount": "1.000",
    "salesPrice": "16.99",
    "originalPrice": "16.99",
    "itemInfo": {
      "productGroupNumber": 7000,
      "productGroupDesc": "Wohnen & Haushalt",
      "subGroupNumber": 700310,
      "subGroupDesc": "Gardinen & Vorhänge",
      "supplierNumber": 6700,
      "supplierDesc": "toom",
      "supplierItemText": "Gardinenstangen-Set 'Cap' Metall schwarz 130 - 240 cm",
      "refNumber": "6371073",
      "rating": 4.5,
      "votings": 142,
      "organic": false,
      "salesAreaNumber": 430,
      "salesAreaDesc": "Gardinen & Gardinentechnik",
      "ean": "9512037846618"
    }
  },
  {
    "amount": "1.000",
    "salesPrice": "6.99",
    "originalPrice": "6.99",
    "itemInfo": {
      "productGroupNumber": 8000,
      "productGroupDesc": "Garten & Freizeit",
      "subGroupNumber": 800210,
      "subGroupDesc": "Erden, Dünger & Pflanzenschutz",
      "supplierNumber": 6700,
      "supplierDesc": "toom",
      "supplierItemText": "Rindenmulch 10 - 40 mm 50 l",
      "refNumber": "4530048",
      "rating": 4.2,
      "votings": 37,
      "organic": true,
      "salesAreaNumber": 610,
      "salesAreaDesc": "Torf- & Rindenmulche",
      "ean": "9825103746621"
    }
  },
  {
    "amount": "1.000",
    "salesPrice": "10.99",
    "originalPrice": "10.99",
    "itemInfo": {
      "productGroupNumber": 8000,
      "productGroupDesc": "Garten & Freizeit",
      "subGroupNumber": 800220,
      "subGroupDesc": "Blumenerde & Pflanzenerde",
      "supplierNumber": 6700,
      "supplierDesc": "toom",
      "supplierItemText": "Blumenerde torffrei 50 l",
      "refNumber": "4520382",
      "rating": 4.4,
      "votings": 211,
      "organic": true,
      "salesAreaNumber": 620,
      "salesAreaDesc": "Erden & Pflanzenschutz",
      "ean": "9587210045632"
    }
  }
];
